import { isEntry } from "./guards";

// The product builder owns the commercial call to action on a PDP, so a module
// pitching a separate offer must never render alongside it — it competes with the
// builder's own add-to-cart flow. Editors can still place these modules freely on
// non-builder pages.
const MODULES_BLOCKED_BY_PRODUCT_BUILDER = new Set(["promotionHighlights"]);

const PRODUCT_BUILDER = "productBuilder";

function contentTypeIdOf(module: unknown): string | null {
  return isEntry(module) ? module.sys.contentType.sys.id : null;
}

/**
 * Filters a page's `modules` down to what may render together. Unresolved links pass
 * through so callers keep their own handling for them.
 */
export function getRenderableModules<T>(modules: readonly T[] | undefined): T[] {
  if (!modules) return [];

  const hasProductBuilder = modules.some(module => contentTypeIdOf(module) === PRODUCT_BUILDER);
  if (!hasProductBuilder) return [...modules];

  return modules.filter(module => {
    const contentTypeId = contentTypeIdOf(module);
    if (contentTypeId === null) return true;
    return !MODULES_BLOCKED_BY_PRODUCT_BUILDER.has(contentTypeId);
  });
}
